var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 19.3691C12.6004 19.3691 13.087 19.8558 13.087 20.4561V22.9127C13.087 23.513 12.6004 23.9996 12.0001 23.9996C11.3997 23.9996 10.9131 23.513 10.9131 22.9127V20.4561C10.9131 19.8558 11.3997 19.3691 12.0001 19.3691Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 0C12.6004 0 13.087 0.486651 13.087 1.08696V3.54352C13.087 4.14383 12.6004 4.63048 12.0001 4.63048C11.3997 4.63048 10.9131 4.14383 10.9131 3.54352V1.08696C10.9131 0.486651 11.3997 0 12.0001 0Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2099 17.21C17.6344 16.7855 18.3226 16.7855 18.7471 17.2099L20.4863 18.9489C20.9108 19.3734 20.9108 20.0616 20.4863 20.4861C20.0619 20.9106 19.3736 20.9107 18.9491 20.4862L17.21 18.7472C16.7855 18.3227 16.7855 17.6345 17.2099 17.21Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5137 3.51366C3.9382 3.08918 4.62643 3.0892 5.0509 3.5137L6.79005 5.25295C7.21452 5.67745 7.2145 6.36568 6.79001 6.79015C6.36551 7.21462 5.67728 7.2146 5.25281 6.79011L3.51366 5.05086C3.08918 4.62636 3.0892 3.93813 3.5137 3.51366Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3701 12.0001C19.3701 11.3997 19.8568 10.9131 20.4571 10.9131H22.9136C23.5139 10.9131 24.0006 11.3997 24.0006 12.0001C24.0006 12.6004 23.5139 13.087 22.9136 13.087H20.4571C19.8568 13.087 19.3701 12.6004 19.3701 12.0001Z",
    fill: "#0F20E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.0001C0 11.3997 0.486651 10.9131 1.08696 10.9131H3.5435C4.14381 10.9131 4.63046 11.3997 4.63046 12.0001C4.63046 12.6004 4.14381 13.087 3.5435 13.087H1.08696C0.486651 13.087 0 12.6004 0 12.0001Z",
    fill: "#0F20E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4863 3.51365C20.9108 3.93813 20.9108 4.62635 20.4863 5.05085L18.7472 6.7901C18.3227 7.2146 17.6345 7.21462 17.21 6.79015C16.7855 6.36568 16.7855 5.67745 17.2099 5.25295L18.9491 3.5137C19.3736 3.0892 20.0618 3.08918 20.4863 3.51365Z",
    fill: "#0F20E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79006 17.21C7.21453 17.6345 7.2145 18.3227 6.78999 18.7472L5.05084 20.4862C4.62633 20.9107 3.93811 20.9106 3.51364 20.4861C3.08917 20.0616 3.08921 19.3734 3.51371 18.9489L5.25286 17.2099C5.67737 16.7855 6.3656 16.7855 6.79006 17.21Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.1230d789d2f2758ef6c79f6eaacc5526.svg";
export { ForwardRef as ReactComponent };